module.exports = require('./helpers/bundle-url').getBundleURL('ldSkg') + "logo-dark.eefe0b7f.svg";